module.exports = __webpack_public_path__ + "static/media/re.70ccb1a9.svg";